import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface VariableInfo {
  path: string;
  type: string;
  value: any;
}

interface VariablesState {
  variableDetails: VariableInfo[];
}

const initialState: VariablesState = {
  variableDetails: [],
};

export const variablesSlice = createSlice({
  name: 'variables',
  initialState,
  reducers: {
    setVariableDetails: (state, action: PayloadAction<VariableInfo[]>) => {
      state.variableDetails = action.payload;
    },
    clearVariablePaths: (state) => {
      state.variableDetails = [];
    },
  },
});

export const { setVariableDetails, clearVariablePaths } = variablesSlice.actions;
export default variablesSlice.reducer;